module.exports = ".maps-tab-row .dropdown-menu {\n  display: block;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/popups/my-stuff/removed-items/removed-maps/removed-maps.component.less
// module id = ./src/app/components/popups/my-stuff/removed-items/removed-maps/removed-maps.component.less
// module chunks = main